import { IonCol, IonGrid, IonRow } from "@ionic/react";
import { FormattedMessage, useIntl } from "react-intl";
import { useHistory } from "react-router";

import styles from "@components/v1/ArticleHeader.module.css";
import Button from "@components/v2/buttons/Button";
import { imageUrl } from "@utils/imageUtils";

type Props = {
  articleId: string;
};

const ArticleHeader = ({ articleId }: Props) => {
  const history = useHistory();
  const intl = useIntl();

  const handleLogin = () => {
    sessionStorage.setItem("postLoginRedirectTo", `/client/articles/${articleId}`);
    history.push("/sign-up");
  };

  return (
    <IonGrid className="ion-no-margin ion-no-padding">
      <IonRow className="ion-no-margin ion-no-padding">
        <IonCol>
          <IonGrid className={`${styles.unauthenticatedHeader} ion-no-padding ion-no-margin`}>
            <IonRow className={`ion-no-padding ion-align-items-center ion-no-margin ${styles.pageContent}`}>
              <IonCol>
                <img alt={intl.formatMessage({ id: "accessibility.altTags.whiteLogo" })} src={imageUrl("logoWhite")} />
              </IonCol>
              <IonCol className={styles.textRight}>
                <Button onClick={handleLogin}>
                  <FormattedMessage id="pages.article.signUpOrLogIn" />
                </Button>
              </IonCol>
            </IonRow>
          </IonGrid>
        </IonCol>
      </IonRow>
    </IonGrid>
  );
};

export default ArticleHeader;
